import { TabScreenWrapper } from '@/components/layout/tab-screen-wrapper';
import { PageTitle } from '@/components/seo/page-title';
import { ActivityScreen } from '@/features/activity/activity-screen';
import React from 'react';

export default function ActivityTab() {
  return (
    <>
      <PageTitle title="Activity" />
      <TabScreenWrapper>
        <ActivityScreen />
      </TabScreenWrapper>
    </>
  );
}
